<template>
  <v-list
    shaped
    :dense="$vuetify.breakpoint.smAndUp"
    :style="{ 'padding-top': $vuetify.breakpoint.lgAndUp ? '2rem' : '' }"
  >
    <v-list-item class="quick-add-button">
      <QuickAddButton></QuickAddButton>
    </v-list-item>

    <v-list-item :to="{ name: 'StatisticsIndex' }" color="primary">
      <v-list-item-icon>
        <v-icon>fa-th-large</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Tableau de bord</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="getIsAdmin"
      :to="{ name: 'AnalyticIndex' }"
      color="primary"
    >
      <v-list-item-icon>
        <v-icon>fa-chart-pie</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Ventes</v-list-item-title>
    </v-list-item>

    <v-list-item :to="{ name: 'RecipeIndex' }" color="primary">
      <v-list-item-icon>
        <v-icon size="30px">mdi-food-fork-drink</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Recettes</v-list-item-title>
    </v-list-item>

    <v-list-item :to="{ name: 'PreparationIndex' }" color="primary">
      <v-list-item-icon>
        <v-icon size="30px">mdi-nutrition</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Préparations</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="getIsAdmin"
      :to="{ name: 'RecipeProductsIndex' }"
      color="primary"
    >
      <v-list-item-icon>
        <v-icon>fa-carrot</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Produits</v-list-item-title>
    </v-list-item>

    <v-list-group v-if="getIsAdmin && showAdvanced">
      <template slot="prependIcon">
        <v-icon>fa-boxes</v-icon>
      </template>
      <v-list-item slot="activator">
        <v-list-item-title>Inventaires</v-list-item-title>
      </v-list-item>
      <v-list-item exact :to="{ name: 'InventoryIndex' }">
        <v-list-item-title class="pl-4"
          >Suivi et prise d'inventaire</v-list-item-title
        >
      </v-list-item>
      <v-list-item exact :to="{ name: 'InventoryTemplateEditor' }">
        <v-list-item-title class="pl-4"
          >Organisation de l'inventaire</v-list-item-title
        >
      </v-list-item>
      <v-list-item exact :to="{ name: 'InventoryWasteCauseIndex' }">
        <v-list-item-title class="pl-4">Raisons de perte</v-list-item-title>
      </v-list-item>
    </v-list-group>
    <v-list-item v-else :to="{ name: 'InventoryIndex' }">
      <v-list-item-icon>
        <v-icon>fa-boxes</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Inventaires</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="getIsAdmin && showAdvanced"
      :to="{ name: 'SuppliersIndex' }"
      color="primary"
    >
      <v-list-item-icon>
        <v-icon>fa-building</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Fournisseurs</v-list-item-title>
    </v-list-item>

    <v-list-group v-if="getIsAdmin && showAdvanced">
      <template slot="prependIcon">
        <v-icon>fa-tasks</v-icon>
      </template>
      <v-list-item slot="activator">
        <v-list-item-title>Bons de préparation</v-list-item-title>
      </v-list-item>
      <v-list-item :to="{ name: 'PreparationSlipIndex' }">
        <v-list-item-title class="pl-4">Suivi et création</v-list-item-title>
      </v-list-item>
      <v-list-item exact :to="{ name: 'PreparationSlipTemplateIndex' }">
        <v-list-item-title class="pl-4">Gabarits</v-list-item-title>
      </v-list-item>
      <!-- <v-list-item exact :to="{ name: 'AutomaticPrepSlipIndex' }">
        <v-list-item-title class="pl-4"
          >Préparations automatisées</v-list-item-title
        >
      </v-list-item> -->
    </v-list-group>

    <v-list-group v-if="getIsAdmin && showAdvanced">
      <template slot="prependIcon">
        <v-icon>fa-truck-loading</v-icon>
      </template>
      <v-list-item slot="activator">
        <v-list-item-title>Bons de commande</v-list-item-title>
      </v-list-item>

      <v-list-item exact :to="{ name: 'DeliverySlipIndex' }">
        <v-list-item-title class="pl-4">Suivi et création</v-list-item-title>
      </v-list-item>
      <v-list-item exact :to="{ name: 'DeliverySlipHistory' }">
        <v-list-item-title class="pl-4">Historique</v-list-item-title>
      </v-list-item>
      <v-list-item exact :to="{ name: 'OrderTemplateIndex' }">
        <v-list-item-title class="pl-4">Gabarits</v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-item
      v-if="getIsAdmin && showAdvanced"
      :to="{ name: 'TagManagerIndex' }"
      color="primary"
    >
      <v-list-item-icon>
        <v-icon>fa-hashtag</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Gestion des mots clés</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="getIsAdmin && showAdvanced"
      :to="{ name: 'CustomUnitIndex' }"
      color="primary"
    >
      <v-list-item-icon>
        <v-icon>fa-balance-scale-left</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Gestion des unités</v-list-item-title>
    </v-list-item>

    <!-- <v-divider class="my-3" v-show="getUserLevel > 0 && getIsAdmin"></v-divider> -->

    <!-- <v-list-group
      v-show="getUserLevel > 0 && getIsAdmin"
      prepend-icon="fa-shipping-fast"
    >
      <v-list-item slot="activator">
        <v-list-item-title>Comptes clients</v-list-item-title>
      </v-list-item>
      <v-list-item :to="{ name: 'CustomerAccountIndex' }">
        <v-list-item-title>Commandes et factures</v-list-item-title>
      </v-list-item>
      <v-list-item :to="{ name: 'CustomerIndex' }">
        <v-list-item-title>Clients</v-list-item-title>
      </v-list-item>
      <v-list-item :to="{ name: 'CustomerAccountProductIndex' }">
        <v-list-item-title>Produits</v-list-item-title>
      </v-list-item>
    </v-list-group> -->
    <!-- <v-list-item
      v-show="getUserLevel > 0 && getIsAdmin"
      :to="{ name: 'TillIndex' }"
      color="primary"
    >
      <v-list-item-icon>
        <v-icon>fa-cash-register</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="pl-4">Caisse</v-list-item-title>
    </v-list-item> -->

    <v-list-item v-if="getIsAdmin" style="margin-top: 5rem;">
      <v-switch v-model="showAdvanced" label="Menu détaillé"></v-switch>
    </v-list-item>
    <UserSettingsEditor v-if="getIsAdmin"></UserSettingsEditor>
  </v-list>
</template>

<script>
import QuickAddButton from "./QuickAddButton";
import { mapGetters } from "vuex";
import { UserSettingsEditor } from "@/modules/UserSettings/components";
export default {
  name: "NavigationDrawerList",
  components: {
    QuickAddButton,
    UserSettingsEditor
  },
  computed: {
    ...mapGetters([
      "getIsAdmin",
      "getUserLevel",
      "getShowAdvanced",
      "getRecipes",
      "getProducts"
    ]),
    showAdvanced: {
      get() {
        return this.getShowAdvanced;
      },
      set(v) {
        this.$store.commit("setShowAdvanced", v);
      }
    },
    getUnconfiguredProduct() {
      let count = 0;
      this.getProducts.forEach(x => {
        if (!x.data && x.is_deleted === false) {
          count += 1;
        }
      });
      return count;
    },
    getUnconfiguredRecipe() {
      let count = 0;
      this.getRecipes.forEach(x => {
        if (!x.data && x.is_deleted === false) {
          count += 1;
        }
      });
      return count;
    }
  }
};
</script>

<style lang="scss" scoped>
.quick-add-button {
  background-color: rgba(70, 201, 58, 0.1) !important;
  border-bottom-right-radius: 32px !important;
  border-top-right-radius: 32px !important;
  margin-bottom: 1rem;
}
</style>
